import basicController from 'servicestack/basic.controller.properties'
import ServiceBus from 'servicestack/service-bus'
import CreateMedia from 'emun.on-demand/lib/create-media'
import modals from 'webmodals/modals'
import webutils from 'webutils/services/util'

class UploadMediaController {
    constructor() {
        basicController(this)
        const $ctrl = this;
        $ctrl.bus = new ServiceBus();
        Object.assign($ctrl, webutils.deserializeQueryString(location.search));
    }

    upload($files) {
        let $ctrl = this;
        if($files && $files.length){
            $ctrl.$files = $files;
            $ctrl.uploading = {};
            let req = {
                request: {
                    notifySubscription: $ctrl.notifySubscription || $ctrl.NotifySubscription || $ctrl.subscriptionId || $ctrl.SubscriptionId,
                    tags: {Swanky:['from phone']}
                },
                files: $files
            };

            $ctrl.bus.upload('CreateMedia.json', req).then(
                res => $ctrl.message='Image uploaded! Feel free to add another.',
                res => modals.alert(JSON.stringify(res),$ctrl.message='Could not save image!'));
        }
    }

    uploadNew($files) {
        let $ctrl = this;
        if($files && $files.length) {
            let req = {
                notifySubscription: $ctrl.subscriptionId,
                tags: {Swanky:['from phone']}
            };
            var cm = $ctrl.createMedia = new CreateMedia($files, req);
            cm.all.finally(() => console.log('uploaded', arguments));
        }
    }
}

export default UploadMediaController;